/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, fonts, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: 2,
      paddingHorizontal: 8,
    },
    text: {
      flex: 1,
      flexDirection: 'row',
      fontSize: globalScale * 18,
      color: colors.white,
      padding: globalScale * 8,
      borderRadius: globalScale * 8,
      overflow: 'hidden',
      fontFamily: fonts.primary,
    },
    link: {
      color: colors.accentLight,
    },
  };
};

export default getStyles;
